import React, { useMemo } from 'react'
import { FaCopy } from 'react-icons/fa'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import QR from '@resources/imgs/pixqrcode-proseed.jpeg'
import QR_BIOFENIX from '@resources/imgs/pixqrcode-biofenix.jpeg'
import QR_BIOLOGISTICA from '@resources/imgs/pixqrcode-biologistica.jpeg'
import ItauLogo from '@resources/imgs/itau-logo.png'
import IShippingCompany from '@interfaces/IShippingCompany'

interface PixProps {
  shippingCompany?: IShippingCompany | null
  price?: number
}

const SweetAlert = withReactContent(Swal)

const Pix: React.FC<PixProps> = ({ shippingCompany, price }) => {
  const pixKey = shippingCompany?.pix_key || '05.377.107/0001-77'

  const handleCopyPixKey = () => {
    navigator.clipboard.writeText(pixKey)
    SweetAlert.fire({
      title: 'Copiado!',
      text: 'Chave PIX copiada para a área de transferência.',
      icon: 'success',
      confirmButtonText: 'Ok',
      timer: 2000,
      timerProgressBar: true,
    })
  }

  const formattedPrice = useMemo(() => {
    if (price === undefined || price === null) return null
    return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  }, [price])

  const qrCodeImage = useMemo(() => {
    if (shippingCompany?.pix_key_image) {
      return shippingCompany.pix_key_image
    }

    const companyName = shippingCompany?.name || ''

    if (companyName.includes('Biofênix')) {
      return QR_BIOFENIX
    }

    if (companyName.includes('Biologística')) {
      return QR_BIOLOGISTICA
    }

    return QR
  }, [shippingCompany])

  return (
    <div>
      {/* QR Code + Bank Info */}
      <div className="d-flex flex-column flex-md-row" style={{ gap: '16px' }}>
        {/* QR Code */}
        <div className="d-flex flex-column align-items-center" style={{ flexShrink: 0 }}>
          <div className="p-2" style={{
            borderRadius: '10px',
            border: '2px solid #e9ecef',
            backgroundColor: '#fff',
            display: 'inline-block',
          }}
          >
            <img src={qrCodeImage} alt="QR Code PIX" style={{ width: '110px', height: '110px', borderRadius: '6px' }} />
          </div>
          <div className="flex-grow-1" />
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center mt-2 px-3 py-2"
            onClick={handleCopyPixKey}
            style={{
              backgroundColor: '#E8EEFF',
              color: '#4d61aa',
              border: '1px solid #d0d8f0',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '0.80rem',
              transition: 'all 0.2s',
              height: '41px',
            }}
          >
            <FaCopy size={14} className="mr-2" />
            Copiar chave PIX
          </button>
        </div>

        {/* Bank Info */}
        <div className="flex-grow-1 d-flex flex-column">
          <div className="d-flex align-items-center mb-2">
            <img src={ItauLogo} alt="Itaú" style={{ width: '22px', height: '22px', marginRight: '8px' }} />
            <span style={{ fontWeight: 700, fontSize: '0.95rem', color: '#212529' }}>Banco Itaú</span>
            <span className="ml-2 px-2 py-1" style={{
              backgroundColor: '#E8EEFF',
              color: '#4d61aa',
              borderRadius: '6px',
              fontSize: '0.7rem',
              fontWeight: 600,
            }}
            >341</span>
          </div>

          <div className="row">
            <div className="col-6 mb-1">
              <span className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Agência</span>
              <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#212529' }}>{shippingCompany?.agency || '8712'}</span>
            </div>
            <div className="col-6 mb-1 text-right text-lg-left">
              <span className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Conta Corrente</span>
              <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#212529' }}>{shippingCompany?.account || '03865-5'}</span>
            </div>
          </div>

          <div className="mb-1">
            <span className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Chave PIX</span>
            <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#4d61aa' }}>{pixKey}</span>
          </div>

          <div className="flex-grow-1" />

          <div className="p-2" style={{
            borderRadius: '6px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
          }}
          >
            <span style={{ fontWeight: 600, fontSize: '0.8rem', color: '#495057' }}>
              {shippingCompany?.name || 'Feher Serviços Ltda (Pro-Seed)'}
            </span>
          </div>
        </div>
      </div>

      {/* Price */}
      {formattedPrice && (
        <div className="p-2 mt-3 d-flex align-items-center justify-content-between" style={{
          borderRadius: '8px',
          backgroundColor: '#fff8fa',
          border: '1px solid #fde2e9',
        }}
        >
          <span style={{ fontSize: '0.85rem', color: '#495057' }}>Valor a pagar:</span>
          <span style={{ fontSize: '1.1rem', fontWeight: 700, color: '#FA5A84' }}>{formattedPrice}</span>
        </div>
      )}
    </div>
  )
}

export default Pix
